module.exports = __webpack_public_path__ + "static/parallax-sword-8020a10373423f6fd0ef21979b37ae9a.mp4";